import React, { Component } from 'react';
import AusstellungenItem from '../components/AusstellungenItem'; 
import Equalizer from 'react-equalizer';

class Ausstellungen extends Component {
	componentWillMount(){
		window.addEventListener('resize', function(){
            if(window.innerWidth<992){
				let total = document.getElementsByClassName('article-item');
				for(let i=0;i<total.length;i++){
					total[i].removeAttribute('style');
				}
			}
        })
	}
	render(){
		return(			
			<Equalizer byRow={false} className="row" enabled={() => window.matchMedia("(min-width: 992px)").matches}>
				{
					this.props.list.map( (data,i)=>{
						if(data.slug!==this.props.skip)
						return <AusstellungenItem {...data} key={i} />		
						else return null
					}) 
				}
			</Equalizer>
		)
	}	
}
export default Ausstellungen;



// WEBPACK FOOTER //
// ./src/components/Ausstellungen.js